<template>
  <div id="registered-customers">
    <!-- Modal de Listar Resumo dos Clientes -->
    <div id="modal-list" class="modal fade" tabindex="-1">
      <div class="modal-dialog modal-full">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Resumo</h5>
            <button type="button" class="close" data-dismiss="modal">
              &times;
            </button>
          </div>

          <div class="modal-body">
            <table class="table table-striped table-sm font-size-xs">
              <thead>
                <tr>
                  <th>Cliente</th>
                  <th class="text-center">Status</th>
                  <th class="text-center">Classificação</th>
                  <th class="text-center">Tipo</th>
                  <th class="text-center">Pergunta 1</th>
                  <th class="text-center">Pergunta 2</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="customer in registeredCustomers"
                  :key="customer.PS_CLIENTE_ID"
                >
                  <td>
                    <strong>{{ customer.PS_CLIENTE_NOME }}</strong> (CODCFO:
                    {{ customer.PS_CLIENTE_CODCFO }})
                  </td>
                  <td
                    class="text-center"
                    v-html="customerLabelTranslate(customer.PS_CLIENTE_STATUS)"
                  ></td>
                  <td
                    class="text-center"
                    v-html="
                      customerClassLabelTranslate(
                        customer.PS_CLIENTE_CLASSIFICACAO,
                      )
                    "
                  ></td>
                  <td>{{ customer.PS_TC_NOME }}</td>
                  <td
                    class="text-center"
                    v-html="
                      satisfactionLabelTranslate(
                        customer.PS_CLIENTE_NOTA_PERGUNTA1,
                      )
                    "
                  ></td>
                  <td
                    class="text-center"
                    v-html="
                      enchantmentLabelTranslate(
                        customer.PS_CLIENTE_NOTA_PERGUNTA2,
                      )
                    "
                  ></td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-link text-primary"
              data-dismiss="modal"
            >
              Fechar
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- /Modal de Listar Resumo dos Clientes -->

    <!-- Modal de Adicionar Cliente Manualmente -->
    <div id="modal-add-customer" class="modal fade" tabindex="-1">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <form @submit.prevent="insertCustomer">
            <div class="modal-header">
              <h5 class="modal-title">Cadastrar Cliente</h5>
              <button type="button" class="close" data-dismiss="modal">
                &times;
              </button>
            </div>
            <div class="modal-body">
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group">
                    <label
                      >Nome do Cliente: (<span class="text-danger">*</span
                      >)</label
                    >
                    <input
                      type="text"
                      class="form-control"
                      placeholder="Nome do Cliente"
                      v-model="manualClient.PS_CLIENTE_NOME"
                      required
                    />
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-group">
                    <label>CODCFO: (<span class="text-danger">*</span>)</label>
                    <input
                      type="text"
                      class="form-control"
                      placeholder="Nome do Cliente"
                      v-model="manualClient.PS_CLIENTE_CODCFO"
                      required
                    />
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-group">
                    <label
                      >Coligada: (<span class="text-danger">*</span>)</label
                    >
                    <input
                      type="number"
                      class="form-control"
                      placeholder="Nome do Cliente"
                      v-model="manualClient.PS_CLIENTE_COLIGADA"
                      required
                    />
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-group">
                    <label
                      >Tipo de Cliente: (<span class="text-danger">*</span
                      >)</label
                    >
                    <select
                      class="form-control"
                      name="PS_CLIENTE_TC_ID"
                      v-model="manualClient.PS_CLIENTE_TC_ID"
                      required
                    >
                      <option value="" disabled="">Selecione um tipo</option>
                      <option
                        v-for="ct in customerTypes"
                        :key="ct.PS_TC_ID"
                        :value="ct.PS_TC_ID"
                        :title="ct.PS_TC_NOME"
                      >
                        {{ ct.PS_TC_NOME }}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label>E-mail:</label>
                    <input
                      type="email"
                      class="form-control"
                      placeholder="email@email.com"
                      v-model="manualClient.PS_CLIENTE_EMAIL"
                    />
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label
                      >Telefone: (<span class="text-danger">*</span>)</label
                    >
                    <input
                      type="phone"
                      class="form-control"
                      placeholder="Ex: (35) 98888-8888 / 35 98888-8888"
                      required
                      v-model="manualClient.PS_CLIENTE_TELEFONE"
                    />
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="form-group">
                    <label
                      >Observações: (<span class="text-danger">*</span>)</label
                    >
                    <textarea
                      class="form-control"
                      placeholder="Porque você está cadastrando este cliente?"
                      required
                      v-model="manualClient.PS_CLIENTE_OBSERVACOES"
                    />
                  </div>
                </div>
              </div>
            </div>

            <div class="modal-footer">
              <button
                type="button"
                class="btn btn-link text-success"
                data-dismiss="modal"
              >
                Cancelar
              </button>
              <button type="submit" class="btn btn-success">Cadastrar</button>
            </div>
          </form>
        </div>
      </div>
    </div>
    <!-- /Modal de Adicionar Cliente Manualmente -->

    <div class="d-flex">
      <div class="header-title">
        <h3 class="font-weight-light">Clientes Cadastrados</h3>
      </div>
      <div class="ml-auto">
        <button
          type="button"
          class="btn btn-info mr-2"
          data-toggle="modal"
          data-target="#modal-list"
        >
          <i class="fas fa-list"></i>
          Resumo
        </button>
        <button
          type="button"
          class="btn btn-success mr-2"
          data-toggle="modal"
          data-target="#modal-add-customer"
        >
          <i class="fas fa-plus"></i>
          Cadastrar Cliente
        </button>
        <button
          v-if="!selectAgain"
          type="button"
          class="btn btn-warning"
          @click="changeToSelectMode"
        >
          <i class="fas fa-sync-alt mr-2"></i>Selecionar Novamente
        </button>
      </div>
    </div>
    <div class="d-flex">
      <h6 class="">
        Total de Clientes:
        <span class="mr-3">{{ registeredCustomers.length }} </span>
        <span class="mr-2" v-for="(qtd, status) in byStatus" :key="status"
          >| {{ status }}: {{ qtd }}</span
        >
      </h6>
    </div>
    <div
      class="card border-top-dark"
      v-for="(customer, index) in registeredCustomers"
      :key="customer.PS_CLIENTE_ID"
    >
      <div class="card-body">
        <div class="d-flex justify-content-between mb-2">
          <div class="d-flex">
            <div
              class="d-flex mr-2"
              v-html="customerLabelTranslate(customer.PS_CLIENTE_STATUS)"
            ></div>
            <div
              class="d-flex mr-2"
              v-html="
                customerClassLabelTranslate(customer.PS_CLIENTE_CLASSIFICACAO)
              "
            ></div>
          </div>
          <div>
            <span
              class="badge bg-info text-white mr-2 cursor-pointer"
              @click="getComplementarInfo(index)"
            >
              Informações Complementares</span
            >
          </div>
        </div>
        <p>
          Nome do Cliente:
          <strong>{{ customer.PS_CLIENTE_NOME }}</strong> (CODCFO:
          {{ customer.PS_CLIENTE_CODCFO }})
        </p>
        <div class="row">
          <div class="col-md-4">
            <div class="form-group">
              <label>Tipo de Cliente:</label>
              <select
                class="form-control atualizacao_cliente"
                name="PS_CLIENTE_TC_ID"
                v-model="customer.PS_CLIENTE_TC_ID"
                @change="updateCustomer(index)"
              >
                <option value="" disabled="">Selecione um tipo</option>
                <option
                  v-for="ct in customerTypes"
                  :key="ct.PS_TC_ID"
                  :value="ct.PS_TC_ID"
                  :title="ct.PS_TC_NOME"
                >
                  {{ ct.PS_TC_NOME }}
                </option>
              </select>
              <span class="font-size-sm text-muted">Tipo de cliente</span>
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group">
              <label>E-mail:</label>
              <input
                type="email"
                class="form-control atualizacao_cliente"
                name="PS_CLIENTE_EMAIL"
                data-id="2987"
                placeholder="E-mail"
                v-model="customer.PS_CLIENTE_EMAIL"
                @change="updateCustomer(index)"
              />
              <span class="font-size-sm text-muted">Ex: email@dominio.com</span>
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group">
              <label>Telefone:</label>
              <input
                type="text"
                class="form-control atualizacao_cliente"
                name="PS_CLIENTE_TELEFONE"
                data-id="2987"
                placeholder="Telefone"
                v-model="customer.PS_CLIENTE_TELEFONE"
                @change="updateCustomer(index)"
              />
              <span class="font-size-sm text-muted"
                >Ex: (35) 98888-8888 / 35 98888-8888 / 35 988888888</span
              >
            </div>
          </div>
        </div>
        <div v-if="customer.COMPLEMENTAR != ''" class="">
          <div id="informacoes_complementares_1_000516">
            <hr />
            <p class="text-center">
              <strong>Informações Complementares</strong>
            </p>
            <div class="row">
              <div class="col-md-12">
                <p>Telefone Celular: {{ customer.COMPLEMENTAR.TELEX }}</p>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <p>
                  E-mail de Pagamento: {{ customer.COMPLEMENTAR.EMAILPGTO }}
                </p>
              </div>
              <div class="col-md-6">
                <p>
                  Telefone de Pagamento: {{ customer.COMPLEMENTAR.EMAILPGTO }}
                </p>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <p>
                  E-mail de Entrega: {{ customer.COMPLEMENTAR.EMAILENTREGA }}
                </p>
              </div>
              <div class="col-md-6">
                <p>
                  Telefone de Entrega:
                  {{ customer.COMPLEMENTAR.EMAILPEMAILENTREGAGTO }}
                </p>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <p>Contato de Pesquisa: {{ customer.COMPLEMENTAR.CONTPESQ }}</p>
              </div>
              <div class="col-md-6">
                <p>
                  Campo Complementar:
                  {{ customer.COMPLEMENTAR.ATUALIZA_CADASTRO }}
                </p>
              </div>
            </div>
          </div>
        </div>
        <p class="text-center"><strong>Resultado</strong></p>
        <div class="d-flex align-items-center mb-2">
          <div
            class="d-flex mr-2"
            v-html="questionSatisfactionTranslate(unityId)"
          ></div>

          <div
            class="d-flex"
            v-html="
              satisfactionLabelTranslate(customer.PS_CLIENTE_NOTA_PERGUNTA1)
            "
          ></div>
        </div>
        <div v-if="customer.PS_CLIENTE_OBS_PERGUNTA1" class="mb-2">
          <p><u>Comentário:</u> {{ customer.PS_CLIENTE_OBS_PERGUNTA1 }}</p>
        </div>
        <div class="d-flex align-items-center mb-2">
          <div
            class="d-flex mr-2"
            v-html="questionEnchantmentTranslate(unityId)"
          ></div>
          <div
            class="d-flex"
            v-html="
              enchantmentLabelTranslate(customer.PS_CLIENTE_NOTA_PERGUNTA2)
            "
          ></div>
        </div>
        <div v-if="customer.PS_CLIENTE_OBS_PERGUNTA2" class="mb-2">
          <p><u>Comentário:</u> {{ customer.PS_CLIENTE_OBS_PERGUNTA2 }}</p>
        </div>
        <p v-if="customer.PS_CLIENTE_DATA_AVALIACAO">
          Canal utilizado: {{ customer.PS_CLIENTE_CANAL_AVALIACAO }} em
          {{ dateTimeSqlToDateTimeBR(customer.PS_CLIENTE_DATA_AVALIACAO) }}
        </p>
        <hr class="no-margin-top" />
        <p class="no-margin-bottom">
          Último canal de comunicação utilizado:
          {{
            customer.PS_CLIENTE_ULTIMO_CANAL_UTILIZADO
              ? customer.PS_CLIENTE_ULTIMO_CANAL_UTILIZADO +
                ' em ' +
                dateTimeSqlToDateTimeBR(customer.PS_CLIENTE_ULTIMO_CANAL_DATA)
              : 'Não informado'
          }}
        </p>
      </div>
      <div class="card-footer py-1" v-if="customer.MODIFICACAO_DATA">
        <span class="pull-left ml-20 mt-5"
          >Última mov.: {{ customer.MODIFICACAO_USUARIO }} em
          {{ dateTimeSqlToDateTimeBR(customer.MODIFICACAO_DATA) }}</span
        >
      </div>
    </div>
  </div>
</template>

<script>
import {
  customerLabelTranslate,
  customerClassLabelTranslate,
  satisfactionLabelTranslate,
  enchantmentLabelTranslate,
  questionSatisfactionTranslate,
  questionEnchantmentTranslate,
} from '@/utils/statusesTranslator'
import { dateTimeSqlToDateTimeBR } from '@/utils/date'

export default {
  name: 'CustomerRegistered',

  props: {
    unityId: {
      type: Number,
      required: true,
    },
    periodId: {
      type: String,
      required: true,
    },
    selectAgain: {
      type: Boolean,
      required: true,
    },
  },
  components: {},
  data() {
    return {
      registeredCustomers: [],
      customerTypes: [],
      byStatus: [],
      customerLabelTranslate,
      customerClassLabelTranslate,
      satisfactionLabelTranslate,
      enchantmentLabelTranslate,
      questionSatisfactionTranslate,
      questionEnchantmentTranslate,
      dateTimeSqlToDateTimeBR,
      manualClient: {
        PS_CLIENTE_PU_ID: '',
        PS_CLIENTE_PERIODO_ID: this.periodId,
        PS_CLIENTE_UNIDADE_ID: this.unityId,
        PS_CLIENTE_TC_ID: '',
        PS_CLIENTE_COLIGADA: '',
        PS_CLIENTE_CODCFO: '',
        PS_CLIENTE_NOME: '',
        PS_CLIENTE_EMAIL: '',
        PS_CLIENTE_TELEFONE: '',
        PS_CLIENTE_OBS: '',
      },
    }
  },

  computed: {},

  methods: {
    async getRegisteredCustomers() {
      try {
        this.isLoading = true
        const response = await this.$store.dispatch('getRegisteredCustomers', {
          unityId: this.unityId,
          periodId: this.periodId,
        })
        if (response) {
          this.customerTypes = response.customerTypes
          this.registeredCustomers = response.customers
          this.byStatus = response.byStatus
        } else {
          this.registeredCustomers = []
          this.customerTypes = []
          this.$root.$children[0].$refs.notification.danger(
            'Período não encontrado.',
          )
        }

        this.isLoading = false
      } catch (error) {
        if (error && error.message) {
          this.$root.$children[0].$refs.notification.warning(error.message)
        } else {
          this.$root.$children[0].$refs.notification.danger(
            'Não foi possível se conectar ao servidor.',
          )
        }
      }
    },
    async getComplementarInfo(index) {
      try {
        const response = await this.$store.dispatch('getComplementarInfo', {
          unityId: this.unityId,
          periodId: this.periodId,
          customerId: this.registeredCustomers[index].PS_CLIENTE_ID,
        })
        if (response) {
          this.registeredCustomers[index].COMPLEMENTAR = response
          console.log(this.registeredCustomers[index])
        } else {
          this.$root.$children[0].$refs.notification.danger(
            'Informação complementar não encontrada.',
          )
        }
      } catch (error) {
        if (error && error.message) {
          this.$root.$children[0].$refs.notification.warning(error.message)
        } else {
          this.$root.$children[0].$refs.notification.danger(
            'Não foi possível se conectar ao servidor.',
          )
        }
      }
    },
    async updateCustomer(index) {
      try {
        const customer = this.registeredCustomers[index]

        if (customer.PS_CLIENTE_ID) {
          const operation = await this.$store.dispatch('updateCustomer', {
            customerId: customer.PS_CLIENTE_ID,
            periodId: this.periodId,
            unityId: this.unityId,
            customer: {
              PS_CLIENTE_TELEFONE: customer.PS_CLIENTE_TELEFONE,
              PS_CLIENTE_EMAIL: customer.PS_CLIENTE_EMAIL,
              PS_CLIENTE_TC_ID: customer.PS_CLIENTE_TC_ID,
            },
          })
          if (operation.status) {
            this.$root.$children[0].$refs.notification.success(
              operation.message,
            )
          }
        } else {
          this.$root.$children[0].$refs.notification.warning(
            'Cliente não encontrado',
          )
        }
      } catch (error) {
        if (error && error.message) {
          this.$root.$children[0].$refs.notification.warning(error.message)
        } else {
          this.$root.$children[0].$refs.notification.danger(
            'Não foi possível se conectar ao servidor.',
          )
        }
      }
    },
    async insertCustomer() {
      try {
        console.log(this.manualClient)
        const operation = await this.$store.dispatch('insertCustomer', {
          periodId: this.periodId,
          unityId: this.unityId,
          client: this.manualClient,
        })
        if (operation.status) {
          this.$root.$children[0].$refs.notification.success(operation.message)
          window.$('#modal-add-customer').modal('hide')
          this.manualClient = {
            PS_CLIENTE_PU_ID: '',
            PS_CLIENTE_PERIODO_ID: this.periodId,
            PS_CLIENTE_UNIDADE_ID: this.unityId,
            PS_CLIENTE_TC_ID: '',
            PS_CLIENTE_COLIGADA: '',
            PS_CLIENTE_CODCFO: '',
            PS_CLIENTE_NOME: '',
            PS_CLIENTE_EMAIL: '',
            PS_CLIENTE_TELEFONE: '',
            PS_CLIENTE_OBS: '',
          }
          this.getRegisteredCustomers()
        } else {
          this.$root.$children[0].$refs.notification.warning(operation.message)
        }
      } catch (error) {
        if (error && error.message) {
          this.$root.$children[0].$refs.notification.warning(error.message)
        } else {
          this.$root.$children[0].$refs.notification.danger(
            'Não foi possível se conectar ao servidor.',
          )
        }
      }
    },
    changeToSelectMode() {
      this.$emit('selectCostumersAgain', true)
    },
  },

  watch: {
    unityId: {
      handler(newVal, oldVal) {
        if (newVal !== '') {
          this.getRegisteredCustomers()
        }
      },
    },
  },

  mounted() {
    this.getRegisteredCustomers()
  },
}
</script>
